// @flow
import * as type from 'actionTypes';

const initialState = {
	classificationData: null,
	isDuplicateClassification: false,
	isApplicableToAllCommittees: false,
	colorCode: '',
	isAddedColor: false,
	colorName: ''
};

const reducerClassification = (state = initialState, action) => {
	switch (action.type) {

		case type.VIEW_CLASSIFICATION:

			const data = {
				classificationTypeId: action.classificationData.ClassificationTypeId,
				type: action.classificationData.Name,
				description: action.classificationData.Description,
				isApplicableToAllCommittees: action.classificationData.IsApplicableToAllCommittees,
				ColorCode: action.classificationData.ColorCode,
				ColorName: action.classificationData.ColorName
			};

			return {
				...state,
				classificationData: data
			};

		case type.CLASSIFICATION_DUPLICATE:
			return {
				...state,
				isDuplicateClassification: action.isDuplicateClassification
			};
		case type.ADD_CLASSIFICATION:

		case type.EDIT_CLASSIFICATION:

			return {
				...state,
				isDuplicateClassification: action.isDuplicateClassification
			};
		case type.APPLICABLE_ALL_COMMITTEES:
			// classificationData is also the redux-form initialValues, so always return a new object
			return {
				...state,
				classificationData: {
					...state.classificationData,
					isApplicableToAllCommittees: action.isApplicableToAllCommittees
				}
			}
		case type.PICK_COLOR:
			return {
				...state,
				classificationData: {
					...state.classificationData,
					colorCode: action.colorInfo.colorCode,
					isAddedColor: action.colorInfo.isAddedColor,
					colorName: action.colorInfo.colorName
				}
			}
		default:
			return {
				...state,
				isDuplicateClassification: false
			};
	}
};

export default reducerClassification;
